import { If, TabLink } from "components";
import { t } from "i18next";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { Routes } from "modules/common";
import {
  CustomCoupons,
  OrdersResoldCoupons,
  QtyResoldCoupons,
  SharingCoupons,
  ValueResoldCoupons
} from "modules/coupons";
import { useParams } from "react-router-dom";

import styles from "./BonusCouponsPage.module.scss";

const BonusCouponsPage = () => {
  const { activeTab } = useParams();

  const contentRoutes = Routes.find((route) => {
    return route.label === "Coupons";
  })?.nestedRoutes?.find((route) => {
    return route.label === "Bonus Coupons";
  })?.nestedRoutes;

  return (
    <ContentLayout title={t("Bonus Coupons")}>
      <BoxShadowLayout className={styles.page}>
        <If condition={!!contentRoutes}>
          <nav>
            {contentRoutes?.map((route) => (
              <TabLink
                key={route.label}
                pathName={route.path}
                label={route.label}
              />
            ))}
          </nav>
        </If>

        <div className={styles.page_content}>
          <If condition={activeTab === "sharings"}>
            <SharingCoupons />
          </If>
          <If condition={activeTab === "qty-resold"}>
            <QtyResoldCoupons />
          </If>
          <If condition={activeTab === "value-resold"}>
            <ValueResoldCoupons />
          </If>
          <If condition={activeTab === "orders-resold"}>
            <OrdersResoldCoupons />
          </If>
          <If condition={activeTab === "custom"}>
            <CustomCoupons />
          </If>
        </div>
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default BonusCouponsPage;
